import React, { Component } from "react";
import axios from "axios";
import PanelHeader from "../../components/PanelHeader/PanelHeader";
import { Card, Col, Row } from "reactstrap";
import { Spin, Table, Select, Button, Input, Space, Skeleton } from "antd";
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  SearchOutlined,
} from "@ant-design/icons";

class Portability extends Component {
  constructor(props) {
    super(props);
    let currentCustomer = null;
    try {
      currentCustomer = this.props.mainState.user.uuid;
    } catch (error) {
      console.log("No se pudo obtener el usuario: ", error);
    }
    this.state = {
      customer: currentCustomer,
      portability: [],
      portabilityStats: {
        net_portability: null,
        incoming_completed_ports: null,
        outbound_completed_ports: null,
        portability_to_manage: null,
        coverage_changes: null,
      },
      states: [],
      portabilityStates: [],
      allLoaded: false,
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),
      portsWithoutStatesArray: [],
    };
    this.dateFormatter = this.dateFormatter.bind(this);
    this.loadStatesOptions = this.loadStatesOptions.bind(this);
    this.handleStateChange = this.handleStateChange.bind(this);
    this.firstLoadPortability = this.firstLoadPortability.bind(this);
    this.loadPorabilityStates = this.loadPorabilityStates.bind(this);
    this.getCompletedPortabilities = this.getCompletedPortabilities.bind(this);
    this.firstLoadPortabilityStats = this.firstLoadPortabilityStats.bind(this);
  }
  async componentDidMount() {
    await this.firstLoadPortability();
    await this.loadStatesOptions();
    await this.loadPorabilityStates();
    await this.getCompletedPortabilities();
    await this.firstLoadPortabilityStats();
  }
  async firstLoadPortability() {
    try {
      const portabilityCall = await axios.post(
        // "http://localhost:1337/api/mobiles/getPortabilidadesProveedores"
        "https://backoffice.nadu.xyz/api/mobiles/getPortabilidadesProveedores"
      );
      this.setState({ portability: portabilityCall.data });
    } catch (error) {
      console.error("Error al obtener contenido:", error);
    }
  }
  async firstLoadPortabilityStats() {
    try {
      const month =
        this.state.selectedMonth >= 10
          ? String(this.state.selectedMonth)
          : `0${this.state.selectedMonth}`;
      const year = this.state.selectedYear;

      const portabilityStats = await axios.get(
        // `http://localhost:1337/api/get-portability-stats?month=${month}&year=${year}`
        `https://backoffice.nadu.xyz/api/get-portability-stats?month=${month}&year=${year}`
      );
      this.setState({ portabilityStats: portabilityStats.data.data });
    } catch (error) {
      console.error("Error al obtener contenido:", error);
    }
  }
  async loadStatesOptions() {
    try {
      const statesCall = await axios.get(
        // "http://localhost:1337/api/customer-service-states"
        "https://backoffice.nadu.xyz/api/customer-service-states"
      );
      this.setState({ states: statesCall.data });
    } catch (error) {
      console.error("Error al obtener contenido:", error);
    }
  }
  async loadPorabilityStates() {
    try {
      const referencesPortability = this.state.portability.map(
        (portability) => portability.referencia
      );
      const portabilityStatesCall = await axios.post(
        // "http://localhost:1337/api/portabilities/getPortabilitiesInTable",
        "https://backoffice.nadu.xyz/api/portabilities/getPortabilitiesInTable",
        {
          referencesPortability: referencesPortability,
        }
      );
      let portabilityStates = portabilityStatesCall.data;
      for (
        let indexPortability = 0;
        indexPortability < this.state.portability.length;
        indexPortability++
      ) {
        let found = false;
        for (
          let indexPortabilityState = 0;
          indexPortabilityState < portabilityStates.length;
          indexPortabilityState++
        ) {
          if (
            this.state.portability[indexPortability].referencia ===
            portabilityStates[indexPortabilityState].reference
          ) {
            this.state.portability[indexPortability].date =
              portabilityStates[indexPortabilityState].updatedAt &&
              this.dateFormatter(
                portabilityStates[indexPortabilityState].updatedAt,
                true
              );
            this.state.portability[indexPortability].state =
              portabilityStates[
                indexPortabilityState
              ].customer_service_state.name;
            this.state.portability[indexPortability].user =
              portabilityStates[indexPortabilityState].user;
            found = true;
            break;
          }
        }
        if (!found) {
          const updatedPortsWithoutStates = [
            ...this.state.portsWithoutStatesArray,
          ];
          updatedPortsWithoutStates.push(
            this.state.portability[indexPortability]
          );
          this.setState({
            portsWithoutStatesArray: updatedPortsWithoutStates,
          });
        }
      }
      this.setState({ portabilityStates: portabilityStates });
      this.setState({ allLoaded: true });
    } catch (error) {
      console.error("Error al obtener contenido:", error);
    }
  }
  async handleStateChange(value, record) {
    let notNew = false;
    let notNewId;
    for (let index = 0; index < this.state.portability.length; index++) {
      if (
        this.state.portabilityStates[index] &&
        record.referencia === this.state.portabilityStates[index].reference
      ) {
        notNewId = this.state.portabilityStates[index].id;
        notNew = true;
      }
    }
    if (notNew) {
      await axios.put(
        // `http://localhost:1337/api/portabilities/${notNewId}`,
        `https://backoffice.nadu.xyz/api/portabilities/${notNewId}`,
        {
          data: {
            id: notNewId,
            reference: record.referencia,
            customer_service_state: value,
            user: this.state.customer,
            isOut:
              record.type === "OUT"
                ? true
                : record.type === "IN"
                  ? false
                  : record.type === "CHANGE"
                    ? record.subType === "OUT"
                      ? true
                      : false
                    : null,
          },
        }
      );
    } else {
      await axios.post(
        // `http://localhost:1337/api/portabilities/`,
        `https://backoffice.nadu.xyz/api/portabilities/`,
        {
          data: {
            reference: record.referencia,
            customer_service_state: value,
            user: this.state.customer,
            isOut:
              record.type === "OUT"
                ? true
                : record.type === "IN"
                  ? false
                  : record.type === "CHANGE"
                    ? record.subType === "OUT"
                      ? true
                      : false
                    : null,
          },
        }
      );
    }
    this.loadPorabilityStates();
    this.getCompletedPortabilities();
  }
  dateFormatter(date, withHour) {
    const dateObj = new Date(date);
    let formattedDate = "";
    if (withHour) {
      const horas = String(dateObj.getHours()).padStart(2, "0");
      const minutos = String(dateObj.getMinutes()).padStart(2, "0");
      formattedDate += ` ${horas}:${minutos} `;
    }
    const dia = String(dateObj.getDate()).padStart(2, "0");
    const mes = String(dateObj.getMonth() + 1).padStart(2, "0");
    const año = dateObj.getFullYear();
    formattedDate += `${dia}/${mes}/${año}`;
    return formattedDate;
  }
  async getCompletedPortabilities(
    month = new Date().getMonth() + 1,
    year = new Date().getFullYear()
  ) {
    try {
      const filteredPortabilities = this.state.portability.filter(
        (portability) => {
          const formattedPortabilityDate = this.dateFormatter(
            portability.fechaPortabilidad
          );
          const portabilityDateParts = formattedPortabilityDate.split("/");
          const portabilityDate = new Date(
            portabilityDateParts[2],
            portabilityDateParts[1] - 1,
            portabilityDateParts[0]
          );
          const untilDate = new Date();
          untilDate.setDate(untilDate.getDate() - 1);
          return (
            portabilityDate.getMonth() + 1 === month &&
            portabilityDate.getFullYear() === year &&
            portabilityDate <= untilDate
          );
        }
      );
      const OutPortabilities = filteredPortabilities.filter(
        (portability) => portability.type === "OUT"
      );
      const InPortabilities = filteredPortabilities.filter(
        (portability) => portability.type === "IN"
      );
      const completedOutPortabilities = OutPortabilities.length;
      const completedInPortabilities = InPortabilities.length;
      const difference = completedInPortabilities - completedOutPortabilities;
      const totalChangePortabilities = filteredPortabilities.filter(
        (portability) => portability.type === "CHANGE"
      ).length;
      const portabilitiesWithoutState =
        this.state.portsWithoutStatesArray.filter((portability) => {
          const formattedPortabilityDate = this.dateFormatter(
            portability.fechaPortabilidad
          );
          const portabilityDateParts = formattedPortabilityDate.split("/");
          const portabilityMonth = parseInt(portabilityDateParts[1], 10);
          const portabilityYear = parseInt(portabilityDateParts[2], 10);
          return portabilityMonth === month && portabilityYear === year;
        }).length;

      this.setState({
        completedOutPortabilities,
        completedInPortabilities,
        subtractedCompletedPortabilities: difference,
        totalChangePortabilities,
        portabilitiesWithoutState,
      });
    } catch (error) {
      console.error("Error al obtener las portabilidades:", error);
      throw error;
    }
  }

  render() {
    const {
      net_portability,
      incoming_completed_ports,
      outbound_completed_ports,
      portability_to_manage,
      coverage_changes,
    } = this.state.portabilityStats;
    const { Option } = Select;
    const columns = [
      {
        title: "Estado",
        dataIndex: "state",
        key: "state",
        filters: [
          {
            text: "Sin estado",
            value: "null", // Cambiamos el value para que represente registros sin estado
          },
          {
            text: "NC",
            value: "NC",
          },
          {
            text: "Cuelga",
            value: "Cuelga",
          },
          {
            text: "Oferta",
            value: "Oferta",
          },
          {
            text: "Gestionado",
            value: "Gestionado",
          },
        ],
        onFilter: (value, record) => {
          if (value === "null") {
            return !record.state;
          } else {
            return record.state === value;
          }
        },
        render: (estado, record) => {
          if (!record.isSubPort) {
            return (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "left",
                }}
              >
                <Select
                  style={{ width: "8rem" }}
                  dropdownStyle={{ zIndex: 1000 }}
                  value={estado || "Sin estado"}
                  onChange={(value) => this.handleStateChange(value, record)}
                >
                  {this.state.states.data.map((state) => (
                    <Option key={state.id} value={state.id}>
                      {state.attributes.name}
                    </Option>
                  ))}
                </Select>
                <p
                  style={{ fontSize: "0.7rem", paddingLeft: "0.5rem" }}
                  key={record.date}
                >
                  {record.date ? record.date : "Sin fecha"} <br />
                  {record.user ? record.user : "Sin usuario"}
                </p>
              </div>
            );
          }
        },
      },
      {
        title: "Teléfono",
        dataIndex: "telefono",
        key: "telefono",
        filterDropdown: ({
          setSelectedKeys,
          selectedKeys,
          confirm,
          clearFilters,
        }) => (
          <div style={{ padding: 8 }}>
            <Input
              id="searchInput"
              placeholder="Buscar teléfono"
              value={selectedKeys[0]}
              onChange={(e) =>
                setSelectedKeys(e.target.value ? [e.target.value] : [])
              }
              onPressEnter={() => confirm()}
              style={{ width: 188, marginBottom: 8, display: "block" }}
            />
            <Space>
              <Button
                onClick={() => clearFilters()}
                size="small"
                style={{ width: 90, height: "2rem" }}
              >
                Restablecer
              </Button>
              <Button
                type="primary"
                onClick={() => confirm()}
                size="small"
                style={{ width: 90, height: "2rem" }}
              >
                Buscar
              </Button>
            </Space>
          </div>
        ),
        filterIcon: (filtered) => (
          <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
        onFilter: (value, record) =>
          record.telefono.toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
          if (visible) {
            setTimeout(
              () => document.getElementById("searchInput").select(),
              100
            );
          }
        },
      },
      {
        title: "Tipo",
        dataIndex: "type",
        key: "type",
        filters: [
          {
            text: "Salientes",
            value: "OUT",
          },
          {
            text: "Entrantes",
            value: "IN",
          },
          {
            text: "Internas",
            value: "CHANGE",
          },
        ],
        onFilter: (value, record) => {
          if (value === "CHANGE") {
            return record.children !== null;
          } else {
            return record.type === value;
          }
        },
        render: (type, record) => {
          return record.children && type === "IN" ? (
            <i
              className="now-ui-icons arrows-1_refresh-69"
              style={{ color: "green" }}
            />
          ) : record.isSubPort && type === "OUT" ? (
            <i
              className="now-ui-icons arrows-1_refresh-69"
              style={{ color: "red" }}
            />
          ) : type === "OUT" ? (
            <ArrowUpOutlined style={{ color: "red" }} />
          ) : (
            type === "IN" && <ArrowDownOutlined style={{ color: "green" }} />
          );
        },
        align: "center",
      },
      {
        title: "Fecha de portabilidad",
        dataIndex: "fechaPortabilidad",
        key: "fechaPortabilidad",
        render: (fechaPortabilidad) => this.dateFormatter(fechaPortabilidad),
        sorter: (a, b) => {
          const dateA = new Date(a.fechaPortabilidad);
          const dateB = new Date(b.fechaPortabilidad);
          return dateA - dateB;
        },
        showSorterTooltip: false,
      },
      {
        title: "Proveedor",
        dataIndex: "providerParent",
        key: "providerParent",
        sorter: (a, b) => a.providerParent.localeCompare(b.providerParent),
        showSorterTooltip: false,
        filters: [
          {
            text: "Sin información",
            value: "null",
          },
          {
            text: "Lemon",
            value: ["Lemon", "LEMONVIL"],
          },
          {
            text: "Yoigo",
            value: "YOIGO",
          },
          {
            text: "TTB",
            value: "TTB",
          },
          {
            text: "Aire",
            value: ["AIRENETWORKS", "Aire"],
          },
          {
            text: "OnMovil",
            value: "OnMovil",
          },
          {
            text: "Movistar",
            value: "MOVISTAR",
          },
          {
            text: "DIGI SPAIN TELECOM",
            value: "DIGI SPAIN TELECOM",
          },
        ],
        onFilter: (value, record) => {
          if (value === "null") {
            return !record.providerParent;
          } else if (Array.isArray(value)) {
            return value.includes(record.providerParent);
          } else {
            return record.providerParent === value;
          }
        },
      },
      {
        title: "Destino",
        dataIndex: "destino",
        key: "destino",
        sorter: (a, b) => a.destino.localeCompare(b.destino),
        showSorterTooltip: false,
        filters: [
          {
            text: "Sin información",
            value: ["null"],
          },
          {
            text: "Lemon",
            value: ["Lemon", "LEMONVIL"],
          },
          {
            text: "Yoigo",
            value: "YOIGO",
          },
          {
            text: "TTB",
            value: "TTB",
          },
          {
            text: "Aire",
            value: ["AIRENETWORKS", "Aire"],
          },
          {
            text: "OnMovil",
            value: "OnMovil",
          },
          {
            text: "Movistar",
            value: "MOVISTAR",
          },
          {
            text: "DIGI SPAIN TELECOM",
            value: "DIGI SPAIN TELECOM",
          },
        ],

        onFilter: (value, record) => {
          if (value === "null") {
            return !record.destino;
          } else if (Array.isArray(value)) {
            return value.includes(record.destino);
          } else {
            return record.destino === value;
          }
        },
      },
    ];
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 20 }, (_, i) => currentYear - 10 + i);
    const months = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];
    const widthScreen = window.innerWidth;
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          <Row style={{ width: "100%", height: "100%" }}>
            <Col xs={12}>
              <Card
                style={{
                  display: "flex",
                  flexDirection: "row",
                  padding: "10px",
                  alignItems: "center",
                }}
              >
                Portabilidades
              </Card>
            </Col>
          </Row>
          <div
            style={{
              display: "flex",
              flexDirection: widthScreen > 1250 ? "row" : "column",
              gap: "1rem",
              width: "100%",
            }}
          >
            <Card style={{ padding: "0.5rem" }}>
              {net_portability !== null ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: widthScreen > 1250 ? "row" : "row",
                    width: "100%",
                    gap: "0.5rem",
                    textAlign: "center",
                    height: "100%",
                  }}
                >
                  <Select
                    style={{
                      flex: 1,
                      height: "100%",
                      maxWidth: widthScreen > 1250 ? "50%" : "100%",
                    }}
                    defaultValue={this.state.selectedMonth}
                    onChange={(value) => {
                      this.setState({ selectedMonth: value }, () => {
                        this.firstLoadPortabilityStats();
                      });
                    }}
                  >
                    {months.map((month, index) => (
                      <Option key={index + 1} value={index + 1}>
                        {month}
                      </Option>
                    ))}
                  </Select>
                  <Select
                    style={{
                      flex: 1,
                      height: "100%",
                      maxWidth: widthScreen > 1250 ? "50%" : "100%",
                    }}
                    defaultValue={this.state.selectedYear}
                    onChange={(value) => {
                      this.setState({ selectedYear: value }, () => {
                        this.firstLoadPortabilityStats();
                      });
                    }}
                  >
                    {years.map((year) => (
                      <Option key={year} value={year}>
                        {year}
                      </Option>
                    ))}
                  </Select>
                </div>
              ) : (
                <Skeleton active size={"small"} paragraph={{ rows: 1 }} />
              )}
            </Card>
            <Card
              style={{
                padding: "0.5rem",
              }}
            >
              {net_portability !== null ? (
                <div
                  style={{
                    textAlign: "center",
                    color:
                      net_portability > 0
                        ? "green"
                        : net_portability < 0
                          ? "red"
                          : "inherit",
                  }}
                >
                  {net_portability.label} <br />
                  <b>{net_portability.value}</b>
                </div>
              ) : (
                <Skeleton active size={"small"} paragraph={{ rows: 1 }} />
              )}
            </Card>
            <Card style={{ padding: "0.5rem" }}>
              {incoming_completed_ports !== null ? (
                <div style={{ textAlign: "center", color: "green" }}>
                  {incoming_completed_ports.label} <br />
                  <b>{incoming_completed_ports.value}</b>
                </div>
              ) : (
                <Skeleton active size={"small"} paragraph={{ rows: 1 }} />
              )}
            </Card>
            <Card style={{ padding: "0.5rem" }}>
              {outbound_completed_ports !== null ? (
                <div style={{ textAlign: "center", color: "red" }}>
                  {outbound_completed_ports.label} <br />
                  <b>{outbound_completed_ports.value}</b>
                </div>
              ) : (
                <Skeleton active size={"small"} paragraph={{ rows: 1 }} />
              )}
            </Card>
            <Card style={{ padding: "0.5rem" }}>
              {portability_to_manage !== null ? (
                <div style={{ textAlign: "center", color: "orange" }}>
                  {portability_to_manage.label} <br />
                  <b>{portability_to_manage.value}</b>
                </div>
              ) : (
                <Skeleton active size={"small"} paragraph={{ rows: 1 }} />
              )}
            </Card>
            <Card title="Cambios de cobertura" style={{ padding: "0.5rem" }}>
              {coverage_changes !== null ? (
                <div style={{ textAlign: "center" }}>
                  {coverage_changes.label} <br />
                  <b>{coverage_changes.value}</b>
                </div>
              ) : (
                <Skeleton active size={"small"} paragraph={{ rows: 1 }} />
              )}
            </Card>
          </div>
          {this.state.allLoaded ? (
            <Table
              columns={columns}
              dataSource={this.state.portability.map((portability) => {
                if (portability.subPort) {
                  return {
                    ...portability,
                    children: [
                      { index: 0, ...portability.subPort, isSubPort: true },
                    ],
                  };
                } else {
                  return { ...portability, children: null };
                }
              })}
              style={{ width: "100%" }}
              scroll={{ x: 576 }}
              rowKey="index"
              rowClassName={(record, _) =>
                record.isSubPort && "antd-subports-row"
              }
            />
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "70vh",
              }}
            >
              <Spin />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Portability;



// WEBPACK FOOTER //
// ./src/views/Mobiles/Portability.jsx